import {ContentBlock, ContentState} from 'draft-js';
import {CreateSheet, css} from 'packages/aphrodite/aphrodite';
import {ModProps} from '../Mods.react';
// components
import IsValidURL from 'packages/helpers/IsValidURL';
import {Body, ComponentProps, Footer, Header, Lightbox} from 'packages/lightbox/lightbox';
import React, {PropsWithChildren, useRef, useState} from 'react';
import {MakeButton, PrimaryFilled} from 'src/themes/button';
import {MakeInput, PrimaryInput} from 'src/themes/input';

export type LinkData = {
    url: string;
};

export function LinkStrategy(
    contentBlock: ContentBlock,
    callback: (start: number, end: number) => void,
    contentState: ContentState
) {
    contentBlock.findEntityRanges(character => {
        const entityKey = character.getEntity();
        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
    }, callback);
}

export function LinkComponent({children, contentState, entityKey}: React.PropsWithChildren<ModProps>) {
    const data = contentState.getEntity(entityKey).getData() as LinkData;
    return <LinkRenderer {...{data}}>{children}</LinkRenderer>;
}

type LinkRendererProps = {
    data: LinkData;
};

export const LinkRenderer: React.FC<PropsWithChildren<LinkRendererProps>> = ({data, children}) => (
    <a
        href={data.url}
        target="_blank"
        rel="noopener noreferrer"
    >
        {children}
    </a>
);

export interface InsertLinkLightboxProps {
    onInsert: (url: string) => void;
}

export default function InsertLink(data: ComponentProps<InsertLinkLightboxProps>) {
    const InputRef = useRef<HTMLInputElement>(null);
    const [InputError, SetInputError] = useState(false);

    function insert() {
        if (InputRef.current) {
            SetInputError(false);
            if (!IsValidURL(InputRef.current.value.trim())) {
                SetInputError(true);
            } else {
                data.content?.onInsert(InputRef.current.value.trim());
                data.close();
            }
        }
    }

    function onKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.key === 'Enter') {
            e.preventDefault();
            insert();
        }
    }

    return (
        <Lightbox {...{close: data.close}}>
            <Header>Insert link</Header>
            <Body>
                <input
                    {...{
                        type: 'text',
                        className: css(MakeInput(PrimaryInput, {error: InputError})),
                        ref: InputRef,
                        placeholder: 'http(s)://',
                        onKeyDown,
                    }}
                />
            </Body>
            <Footer {...{styles: Styles.footer}}>
                <button
                    className={css(MakeButton(PrimaryFilled))}
                    onClick={insert}
                >
                    Insert
                </button>
            </Footer>
        </Lightbox>
    );
}
const Styles = CreateSheet({
    footer: {
        padding: '10px 20px',
        textAlign: 'right',
        ':nth-child(1n) button': {
            marginLeft: 10,
        },
    },
});
